@if (selectedNonAvailable$ | async; as selectedNonAvailable) {
  @if (selectedNonAvailable.length > 0) {
    <div class="container justify-content-center text-center p-3">
      @if (selectedNonAvailable.length === 1) {
        <span translate [translateParams]="{title: getTitles(selectedNonAvailable)}">
          FILTER.NO_TRAININGS.SINGULAR
        </span>
      }
      @if (selectedNonAvailable.length > 1) {
        <span translate [translateParams]="{titles: getTitles(selectedNonAvailable)}">
          FILTER.NO_TRAININGS.PLURAL
        </span>
      }
      <span translate>FILTER.NO_TRAININGS.PRE_LINK</span>
      <a class="textlink" href="mailto:info@troodi.de">info&#64;troodi.de</a>
      <span translate>FILTER.NO_TRAININGS.POST_LINK</span>
    </div>
  }
}
@if ((topics$ | async); as topics) {
  @if (!!(emptyTopics$ | async)) {
    <div class="container">
      <div class="empty-content d-flex flex-column flex-grow-1 justify-content-center align-items-center text-center m-5 p-3">
        @if (!(userContactedSales$ | async)) {
          <app-expiration-notice [hasCancelButton]="false" (sendClicked)="send($event)"> </app-expiration-notice>
        }
        @if ((userContactedSales$ | async)) {
          <p class="fw-bold" translate>EXPIRED_USER.INFO_DIALOG.HEADLINE</p>
          <div>
            <span translate>EXPIRED_USER.INFO_DIALOG.TEXT_PRE</span>
            <a class="textlink" href="mailto:info@troodi.de">info&#64;troodi.de</a>
            <span class="dialog-message mailto-suffix" translate>EXPIRED_USER.INFO_DIALOG.TEXT_POST</span>
          </div>
        }
      </div>
    </div>
  } @else {
    @for (topic of topics$ | async; track trackTopic($index, topic)) {
      @if (topic.accessibleTrainingsCount > 0) {
        <app-training-category [topic]="topic"></app-training-category>
      }
    }
  }
}
